// data/items/focuses.js
// Magic offhand items - 6 tiers for spell damage bonus
// Crafted via Glyphbinding (glyph core + ichor)

// Tier definitions - names follow glyph thematic progression
const FOCUS_TIERS = {
    1: { prefix: 'Storm', color: '#87CEEB', spellDamage: 0.05, magicAccuracy: 8, combatLevel: 5, glyphbindingLevel: 15, valueBase: 200 },
    2: { prefix: 'Frost', color: '#1E90FF', spellDamage: 0.10, magicAccuracy: 14, combatLevel: 20, glyphbindingLevel: 30, valueBase: 400 },
    3: { prefix: 'Stone', color: '#8B4513', spellDamage: 0.16, magicAccuracy: 22, combatLevel: 35, glyphbindingLevel: 45, valueBase: 700 },
    4: { prefix: 'Flame', color: '#FF4500', spellDamage: 0.23, magicAccuracy: 32, combatLevel: 50, glyphbindingLevel: 60, valueBase: 1100 },
    5: { prefix: 'Void', color: '#9932CC', spellDamage: 0.31, magicAccuracy: 44, combatLevel: 65, glyphbindingLevel: 75, valueBase: 1600 },
    6: { prefix: 'Spirit', color: '#E6E6FA', spellDamage: 0.40, magicAccuracy: 58, combatLevel: 80, glyphbindingLevel: 90, valueBase: 2400 }
};

// Materials for each tier (glyph core + ichor)
const FOCUS_MATERIALS = {
    1: { coreId: 'common_glyph_core', ichorId: 'arcane_residue', ichorQty: 3 },
    2: { coreId: 'ironwood_glyph_core', ichorId: 'arcane_residue', ichorQty: 5 },
    3: { coreId: 'softbark_glyph_core', ichorId: 'refined_arcane_ichor', ichorQty: 3 },
    4: { coreId: 'goldleaf_glyph_core', ichorId: 'refined_arcane_ichor', ichorQty: 5 },
    5: { coreId: 'gravewood_glyph_core', ichorId: 'purified_arcane_core', ichorQty: 3 },
    6: { coreId: 'arcanewood_glyph_core', ichorId: 'purified_arcane_core', ichorQty: 5 }
};

// Generate focus items
function generateFocuses() {
    const focuses = [];

    for (let tier = 1; tier <= 6; tier++) {
        const tierData = FOCUS_TIERS[tier];
        const materials = FOCUS_MATERIALS[tier];
        const prefixId = tierData.prefix.toLowerCase().replace(/ /g, '_');

        focuses.push({
            id: `${prefixId}_focus`,
            name: `${tierData.prefix} Focus`,
            color: tierData.color,
            tier: tier,
            slot: 'offhand',
            offhandType: 'focus',  // For style validation
            spellDamage: tierData.spellDamage,  // Additive spell damage bonus
            magicAccuracy: tierData.magicAccuracy,
            combatLevel: tierData.combatLevel,
            glyphbindingLevel: tierData.glyphbindingLevel,
            // Crafting materials
            coreId: materials.coreId,
            ichorId: materials.ichorId,
            ichorQty: materials.ichorQty,
            value: tierData.valueBase
        });
    }

    return focuses;
}

export const FOCUSES = generateFocuses();

// Helper to get focus by tier
export function getFocusByTier(tier) {
    return FOCUSES.find(f => f.tier === tier);
}

// Export tier info for crafting UI
export { FOCUS_TIERS, FOCUS_MATERIALS };

export default FOCUSES;
